














































import {
  computed, defineComponent, PropType, useContext,
} from '@nuxtjs/composition-api';
import ProductAccordion from '~/modules/catalog/product/components/ProductAccordion.vue';
import { LinkLabel } from '~/modules/catalog/product/composables/useProductHandler/useProductHandler';
import useUser from '~/modules/customer/composables/useUser';

export default defineComponent({
  name: 'ProductAdditionalInfo',
  components: {
    ProductAccordion,
  },
  transition: 'fade',
  props: {
    purpose: {
      type: Array as PropType<LinkLabel[]>,
      default: () => [],
    },
    czynnikiStresowe: {
      type: Array as PropType<LinkLabel[]>,
      default: () => [],
    },
    kondycjaRosliny: {
      type: Array as PropType<LinkLabel[]>,
      default: () => [],
    },
    substancjaCzynna: {
      type: Array as PropType<LinkLabel[]>,
      default: () => [],
    },
    regeneracjaUpraw: {
      type: Array as PropType<LinkLabel[]>,
      default: () => [],
    },
    aktywacjaUpraw: {
      type: Array as PropType<LinkLabel[]>,
      default: () => [],
    },
    budowaniePlonuIJakosci: {
      type: Array as PropType<LinkLabel[]>,
      default: () => [],
    },
    zwiekszanieOdpornosciUpraw: {
      type: Array as PropType<LinkLabel[]>,
      default: () => [],
    },
    sklad: {
      type: String as PropType<string>,
      default: '',
    },
    terminWaznosci: {
      type: String as PropType<string>,
      default: '',
    },
    formaPakowania: {
      type: Array as PropType<LinkLabel[]>,
      default: () => [],
    },
    formaTransportu: {
      type: Array as PropType<LinkLabel[]>,
      default: () => [],
    },
    pakowanieHurtoweProduktu: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  setup(props) {
    const { i18n } = useContext();
    const { isB2bUser } = useUser();
    const filteredLinksAttributes = computed(() => [
      {
        key: 'czynnikiStresowe',
        title: i18n.t('Stress factors'),
        items: props.czynnikiStresowe,
        b2bOnly: false,
      },
      {
        key: 'kondycjaRosliny',
        title: i18n.t('Plant condition'),
        items: props.kondycjaRosliny,
        b2bOnly: false,
      },
      {
        key: 'substancjaCzynna',
        title: i18n.t('Active substance'),
        items: props.substancjaCzynna,
        b2bOnly: false,
      },
      {
        key: 'purpose',
        title: i18n.t('Purpose'),
        items: props.purpose,
        b2bOnly: false,
      },
      {
        key: 'regeneracjaUpraw',
        title: i18n.t('Crop regeneration'),
        items: props.regeneracjaUpraw,
        b2bOnly: false,
      },
      {
        key: 'aktywacjaUpraw',
        title: i18n.t('Crop activation'),
        items: props.aktywacjaUpraw,
        b2bOnly: false,
      },
      {
        key: 'budowaniePlonuIJakosci',
        title: i18n.t('Yield and quality building'),
        items: props.budowaniePlonuIJakosci,
        b2bOnly: false,
      },
      {
        key: 'zwiekszanieOdpornosciUpraw',
        title: i18n.t('Increasing crop resistance'),
        items: props.zwiekszanieOdpornosciUpraw,
        b2bOnly: false,
      },
      {
        key: 'formaPakowania',
        title: i18n.t('Packaging form'),
        items: props.formaPakowania,
        b2bOnly: true,
      },
      {
        key: 'formaTransportu',
        title: i18n.t('Transport form'),
        items: props.formaTransportu,
        b2bOnly: true,
      },
    ].filter((attr) => attr.items.length > 0));

    const filteredTextAttributes = computed(() => [
      {
        key: 'sklad',
        title: i18n.t('Composition'),
        items: props.sklad,
        b2bOnly: false,
      },
      {
        key: 'terminWaznosci',
        title: i18n.t('Expiration date'),
        items: props.terminWaznosci,
        b2bOnly: false,
      },
      {
        key: 'pakowanieHurtoweProduktu',
        title: i18n.t('Wholesale Product Packaging'),
        items: props.pakowanieHurtoweProduktu ? i18n.t('Yes') : i18n.t('No'),
        b2bOnly: true,
      },
    ].filter((attr) => attr.items !== '' && attr.items !== null));

    const hasLinksAttributes = computed(() => filteredLinksAttributes.value.some((attr) => attr.items.length > 0));
    const hasTextAttributes = computed(() => filteredTextAttributes.value.some((attr) => attr.items !== ''));
    const hasAttributes = computed(() => hasLinksAttributes.value || hasTextAttributes.value);
    return {
      filteredLinksAttributes,
      filteredTextAttributes,
      hasAttributes,
      hasTextAttributes,
      hasLinksAttributes,
      isB2bUser,
    };
  },
});
